var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerblob3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 472.488,
    height: 502.462,
    viewBox: "0 0 472.488 502.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f93"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M359.3,50.574c34.073,36.815,47.154,91.88,41.906,141.618s-28.9,94.23-62.976,143.185S259.661,437.753,213.682,439.242,120.236,390.286,77.86,341.331C35.406,292.375-1.957,244.908.08,199.555,2.194,154.2,43.787,110.887,86.163,74.073c42.454-36.815,85.77-67.128,134.882-73s104.177,12.689,138.25,49.5",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 0, 69.862)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerblob3);
export default __webpack_public_path__ + "static/media/bannerblob3.e1ed9f92abd979b0a4501a285b3bb9b5.svg";
export { ForwardRef as ReactComponent };